import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../../components/angle/Panel/index';
import Spinner from '../../../../components/Spinner/index';
import SelectFundPanel from './SelectFundPanel';
import SubmitElectronicFilingPanel from './SubmitElectronicFilingPanel';
import ElectronicFilingsListGrid from './ElectronicFilingsListGrid';
import { fetchElectronicFilings } from '../../../../services/redux/employee/filing/actions';

class ElectronicFilings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fundSelection: {
                stateId: '',
                clientId: '',
                trustId: '',
                portfolioId: '',
                classId: '',
                prospectusId: ''
            }
        };
    }

    componentDidMount() {
        this.props.fetchElectronicFilings();
    }

    handleFundSelectionChange = fundSelection => {
        this.setState({ fundSelection });
    };

    render() {
        let { filing } = this.props;
        let { fundSelection } = this.state;
        // Nothing below the fund selector is shown until both a class and a
        // state are picked.
        let ready = !!(fundSelection.classId && fundSelection.stateId);
        return (
            <div>
                <div className="col-lg-6 col-md-8 col-sm-12">
                    <Panel showHeader header="Select Fund">
                        <SelectFundPanel
                            onSelectionChange={this.handleFundSelectionChange}
                        />
                    </Panel>
                    {ready && (
                        <SubmitElectronicFilingPanel
                            fundSelection={fundSelection}
                        />
                    )}
                </div>
                {ready && (
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <Panel showHeader header="Electronic Filings">
                            <ElectronicFilingsListGrid
                                id="electronicFilingsGrid"
                                dataList={filing.electronicFilings}
                            />
                        </Panel>
                    </div>
                )}
                {filing.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    filing: state.employee.filing
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchElectronicFilings
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ElectronicFilings);



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ElectronicFilings/index.js